import { BaseModel } from 'app/core/models/base.model';

export class MachineBrand extends BaseModel {
	name: string;
	description: string;
}
